module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "front-index",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('demoMenu'), _vm._v(" "), _c('div', {
    staticClass: "page-right"
  }, [_c('div', {
    staticClass: "page-right-top"
  }, [_c('img', {
    staticClass: "info-icon",
    attrs: {
      "src": require("assets/image/information.svg")
    }
  }), _vm._v(" "), _c('z-lazyImg', {
    staticClass: "user-photo-nav"
  })], 1), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "demo-mask"
  }, [_c('img', {
    attrs: {
      "src": require("assets/image/demo-group@2x.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "front-btn green"
  }, [_vm._v("立即开通")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-e3d1ed8c!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/demo/page-demo.vue
// module id = 790
// module chunks = 1